import { VerifyId } from '@illustrations';
import { Button, Col, MessageBox, Row, StepBox, Typography } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';
import { useTheme } from 'styled-components';
import OnboardingLayout from '@layout/onboarding-layout';
import KycFooter from '../kyc-footer';

interface KycIntroProps {
  afterSubmit: () => void;
}

const KycIntro: React.FunctionComponent<KycIntroProps> = ({ afterSubmit }) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();

  return (
    <OnboardingLayout footer={<KycFooter />}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <VerifyId />
      </div>
      <Typography
        display="h3"
        align="center"
        style={{
          padding: `0 ${theme.spacings.component.S}px`,
          marginTop: theme.spacings.text.XL,
          marginBottom: theme.spacings.text.M,
        }}
      >
        {formatMessage({ id: 'kyc.intro.title' })}
      </Typography>
      <Typography
        display="h6"
        align="center"
        style={{
          color: theme.color.tint.secondary,
          padding: `0 ${theme.spacings.component.S}px`,
        }}
      >
        {formatMessage({ id: 'kyc.intro.description' })}
      </Typography>
      <Typography
        display="body2"
        style={{
          color: theme.color.tint.secondary,
          marginTop: theme.spacings.text.L,
          marginBottom: theme.spacings.text.M,
        }}
      >
        {formatMessage({ id: 'kyc.intro.steps.title' })}
      </Typography>
      <StepBox
        style={{
          marginBottom: theme.spacings.component.L,
          marginLeft: theme.spacings.component.S,
          marginRight: theme.spacings.component.S,
        }}
        items={[
          {
            title: formatMessage({ id: 'kyc.intro.steps.1.title' }),
            description: formatMessage({ id: 'kyc.intro.steps.1.description' }),
          },
          {
            title: formatMessage({ id: 'kyc.intro.steps.2.title' }),
            description: formatMessage({ id: 'kyc.intro.steps.2.description' }),
          },
        ]}
      />

      <MessageBox description={formatMessage({ id: 'kyc.intro.disclaimer' })} />
      <Row justify="end" style={{ marginTop: theme.spacings.component.L }}>
        <Col xs={6}>
          <Button rightArrow onClick={afterSubmit}>
            {formatMessage({ id: 'kyc.submitAction' })}
          </Button>
        </Col>
      </Row>
    </OnboardingLayout>
  );
};

export default React.memo(KycIntro);
